
import React from "react";
import { PARAMETER_OPTIONS } from "../../constants";
import { RillContext } from "../../rill/RillReact/share/base";
import UnitInput from "./unit-input-state";
import RpeInput from "./RpeInput";

const { RPE, RPEAMRAP, TIME, DISTANCE, LOAD, REST, VELOCITY, FREEFORM, REPS } =
  PARAMETER_OPTIONS;
class ParameterInput extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);
  }

  render() {
    const {
      parameter,
      value,
      onChange,
      units,
      tabIndex,
      id,
      intensityMeasure,
      isRiR,
      preferredLoadInput,
      loadDrop,
    } = this.props;

    if (parameter === FREEFORM) {
      return (
        <textarea
          className="text-input-center text-input"
          name="freeform"
          onChange={onChange}
          value={value}
          tabIndex={tabIndex}
          id={id}
        />
      );
    } else if ([TIME, REST, DISTANCE, VELOCITY, REPS].includes(parameter)) {
      return (
        <input
          className="text-input"
          type="text"
          name={parameter.toLowerCase()}
          onChange={onChange}
          value={value}
          maxLength="6"
          tabIndex={tabIndex}
          id={id}
        />
      );
    } else if (parameter === LOAD && preferredLoadInput === "drop") {
      return (
        <div className="relative">
          <input
            tabIndex={tabIndex}
            type="text"
            name="loadDrop"
            value={loadDrop}
            placeholder="%"
            onChange={onChange}
            id={id}
          />
          <span className="load-suffix">%</span>
        </div>
      );
    } else if (parameter === LOAD) {
      return (
        <UnitInput
          name={parameter.toLowerCase()}
          onChange={onChange}
          value={value}
          units={units}
          tabIndex={tabIndex}
          defaultValue={value}
          id={id}
        />
      );
    } else if ([RPE, RPEAMRAP].includes(parameter)) {
      return (
        <RpeInput
          id={id}
          className="text-input"
          name="rpe"
          value={value}
          isRiR={isRiR}
          placeholder={intensityMeasure}
          tabIndex={Number(tabIndex)}
          onChange={onChange}
        />
      );
    }

    return (
      <input
        className="text-input"
        type="number"
        min={1}
        step="1"
        name={parameter.toLowerCase()}
        onChange={onChange}
        value={value}
        tabIndex={tabIndex}
        id={id}
      />
    );
  }
}

ParameterInput.contextType = RillContext;

export default ParameterInput;
